<template>
  <path
    d="M0 21.9999V0.00012207L26.1247 11L0 21.9999ZM2.74997 17.8749L19.0435 11L2.74997 4.12506V8.9375L10.9999 11L2.74997 13.0625V17.8749Z" />
</template>
